module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7ae17c967f58ead058c188ed61eef847.png";